module.exports = __webpack_public_path__ + "img/efund-full-logo.e643275b.png";